import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../../store';
Vue.use(VueI18n)

// 各个国家的key
const localeKeys = ['en', 'zh']

// 各个国家语言包
const messages = {}
for (const key of localeKeys) {
  messages[key] = require(`./locales/${key}.js`).default
}


export default new VueI18n({
  locale: store.getters.getlanguage || 'zh',
  messages,
  silentTranslationWarn: true // 忽略翻译警告
})